const LABELS = {
  active: "Activo",
  archived: "Archivado",
  met: "Cumplido",
  paused: "En pausa",
  present: "Presente",
  absent: "Ausente",
  late: "Tarde",
  justified: "Justificada",
  draft: "Borrador",
  published: "Publicada",
  test: "Prueba",
  assignment: "Trabajo",
  oral: "Actividad oral",
  project: "Proyecto",
  other: "Otra",
  listening: "Listening",
  speaking: "Speaking",
  reading: "Reading",
  writing: "Writing",
  initial: "Inicial",
  developing: "En desarrollo",
  achieved: "Logrado",
  consolidated: "Consolidado",
  admin: "Admin",
  student: "Alumno/a",
  family: "Familia",
};

export const label = (v) => LABELS[v] || v;

export const SKILLS = ["listening", "speaking", "reading", "writing"];
export const ACTIVITY_TYPES = ["test", "assignment", "oral", "project", "other"];

export const fmtScore = (a) =>
  a.score === null || a.score === undefined ? null : `${a.score}/${a.scaleMax}`;

export const scorePct = (a) =>
  a.score === null || a.score === undefined || a.scaleMax === a.scaleMin
    ? null
    : ((a.score - a.scaleMin) / (a.scaleMax - a.scaleMin)) * 100;
